export const Indicator = () => {
  return (
    <div className="w-4 h-4 p-[2px] rounded-full relative">
      <div className="w-full rounded-full h-full bg-action-destructive"></div>
      <div className="w-full rounded-full h-full bg-action-destructive absolute inset-0 animate-indicator"></div>
    </div>
  )
}
